import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { householdSchema, householdUpdateSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const householdsContract = c.router({
  getHousehold: {
    summary: "Get a household by ID",
    method: "GET",
    path: "/households/:id",
    pathParams: z.object({
      id: z.string(),
    }),
    responses: {
      [HTTPStatusCode.OK]: householdSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
    },
  },
  updateHousehold: {
    summary: "Update an existing household by ID",
    method: "PATCH",
    path: "/households/:id",
    pathParams: z.object({
      id: z.uuid(),
    }),
    body: householdUpdateSchema,
    responses: {
      [HTTPStatusCode.OK]: householdSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.FORBIDDEN]: errorSchema,
    },
  },
});
